import React, { forwardRef } from "react";
import { getClassName } from "@sscs/utils";
import FiltersContainer from "../FiltersContainer/FiltersContainer";
import HeaderRow from "../HeaderRow/HeaderRow";
import styles from "./card.module.scss";
const Card = forwardRef(({ fullWidth = true, className, style, children, ...dataAttributes }, ref) => (React.createElement("div", { ref: ref, style: style, className: getClassName(styles.card, { [styles["full-width"]]: fullWidth }, className), ...dataAttributes }, children)));
Card.displayName = "Card";
const Title = ({ as: Heading = "h2", id, className, children, details, actions, }) => {
    if (details === undefined && actions === undefined) {
        return (React.createElement(Heading, { id: id, className: getClassName(styles.title, styles["title-text"], className) }, children));
    }
    return (React.createElement(HeaderRow, { title: children, titleAs: Heading, titleId: id, details: details, actions: actions, classes: {
            root: getClassName(styles.title, className),
            title: styles["title-text"],
            details: styles.detail,
            actions: styles["title-actions"],
        } }));
};
const Content = ({ flush = false, className, children, }) => (React.createElement("div", { className: getClassName(styles.content, className, {
        [styles["flush-content"]]: flush,
    }) }, children));
const Actions = ({ className, children }) => (React.createElement("div", { className: getClassName(styles.actions, className) }, children));
/**
 * Filter band inside a card: a `$surface-canvas` well under `Card.Title` (or first in
 * `Card.Content flush`). Outside a card (e.g. a dialog table) use bare `FiltersContainer`.
 */
const Filters = ({ className, ...props }) => (React.createElement(FiltersContainer, { ...props, className: getClassName(styles.filters, className) }));
export default { Card, Title, Content, Actions, Filters };
//# sourceMappingURL=Card.js.map